import styled from 'styled-components';

export const Title = styled.p`
  font-size: 13px;
`;
